
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import Form2 from "./Form2.vue";
  import Form1 from "./Form1.vue";
  import Counting from "@/views/components/Counting/Counting.vue";
  import {CountingVo} from "@/views/components/Counting/CountingVo";
  import RankingList2 from "@/views/components/RankingList/RankingList2.vue";
  import Scan2 from "@/views/components/Scan/Scan2.vue";
  import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
  import TableHeader from "./TableHeader.vue";
  import {QueueGetOffEntity} from "@/common/Vo/QueueGetOffEntity";
  import config from "./config";
  import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
  import {RankingList} from "@/views/components";
  import { ScanforOutBound_GetOffModule } from "@/store/modules/store_scanforoutbound_getoff";

  @Component({
    name: "ScanForOutboundGetoffSahpe2",
    components: {YtoTable, TableHeader, DeviceItems2, Scan2, RankingList2, Counting, Form2, Form1, RankingList}
  })
  export default class extends Vue {
    @Prop() private tableItems!: QueueGetOffEntity[];
    @Prop() private sendCountVo: sendCountVo;
    @Prop() private buttonVo: ButtonListVo;

    private created(): void {
    }

    private mounted(): void {
      // obj_ScanForOutbound_GetOff.registerJavaScriptCallback('selectScanArea', () => {
      //   // debugger
      //   // _this.$refs.scan.input_selectAll();
      // });
    }

    @Prop() private msg: string;
    @Prop() private ranklistdata: rankListModel;
    @Prop() private ioTypes: ioTypes_Array_Data[];

    @Watch('errorMessage', {deep: true})
    private errorMessageChange(val: string): void {
      this.msg = val;
    }

    get errorMessage(){
      return ScanforOutBound_GetOffModule.errorMessage;
    }
    private setFocus() {
      let scan: any = this.$refs.scan;
      scan.setFocus();
    }

    private ytoRowDbCLick(row, column, event) {
      this.$emit('ytoRowDbCLick', row, column, event);
    }

    private config = config;
    @Prop() private f1: OnCodeGetReqVo;


    public ytoCode: string = '';


    private ytocodeget(e) {
      this.$emit('ytocodeget', this.ytoCode, ...arguments)
    }

    @Prop() private CountVo: CountingVo;

    private delClick(): void {
      let el: any = this.$refs.ytoTable;
      let row = el.getSelectRow();
      if (row) {
        this.$emit('delClick', row)
      } else {
        this.$message.error("请先选择一条数据")
      }
    }

    @Prop() private scacInputDisable: boolean;

    private modifyClick(): void {
      this.$emit('modifyClick', ...arguments);
    }

    private saveClick(): void {
      this.$emit('saveClick', ...arguments)
    }

    private submitClick(): void {
      this.$emit('submitClick', ...arguments);
    }
  }
